import { routeMap } from '../../../router';
import { remotePaths } from 'router/routes';

// Запрос справки о состоянии расчетов (КНД 1166101)
// Запрос акта совместной сверки (КНД 1166101)
// Запрос об исполнении обязанности по уплате налогов (КНД 1166101)
// Заявление о подтверждении права на получение имущественных налоговых вычетов по налогу на доходы физических лиц (КНД 1150074)
// Заявление о выдаче Справки о подтверждении неполучения налогоплательщиком социального налогового вычета либо подтверждении факта получения налогоплательщиком суммы предоставленного социального налогового вычета, предусмотренного подпунктом 4 пункта 1 статьи 219 Налогового кодекса Российской Федерации (КНД 1112526)
// Налоговая декларация по налогу на доходы физических лиц (форма 3-НДФЛ) (КНД 1151020)
export const unavailableSituationsLinksByConvertationStatus = {
  200132: remotePaths.situations,
  200131: remotePaths.situations,
  200133: remotePaths.situations,
  300111: remotePaths.situations,
  200135: remotePaths.social,
  200134: routeMap.propertyTaxDeductions,
};

export default Object.freeze({
  700131: {
    href: routeMap.disposeOfOverpayment,
    icon: 'money',
  },
  300133: { href: routeMap.undefinedObject, icon: 'error' },
  100131: { href: routeMap.applyExemption, icon: 'diploma' },
  100132: { href: routeMap.exemptionsNotification, icon: 'diploma' },
  200131: { href: remotePaths.situations, icon: 'document' },
  200132: { href: remotePaths.situations, icon: 'document' },
  200133: { href: remotePaths.situations, icon: 'document' },
  200134: { href: routeMap.propertyTaxDeductions, icon: 'document' },
  200135: { href: remotePaths.social, icon: 'document' },
  200136: { href: routeMap.factOfGettingSocialDeductions, icon: 'document' },
  300111: { href: remotePaths.situations, icon: 'moneydop' },
  300131: { href: routeMap.updateObjectData, icon: 'error' },
  300132: { href: routeMap.foreignObject, icon: 'error' },
  300134: { href: routeMap.taxNoticeClarification, icon: 'error' },
  400131: { href: routeMap.openingForeignBankAccount, icon: 'chat' },
  400132: { href: routeMap.closingForeignBankAccount, icon: 'chat' },
  400133: { href: routeMap.changeAccountProps, icon: 'chat' },
  400134: { href: routeMap.movementReportForm, icon: 'chat' },
  700132: { href: routeMap.updatePersonalData, icon: 'edit-personal' },
  500131: {
    href: remotePaths.needHardCopy,
    icon: 'pochta',
    // hardCopy: resolveHardCopy,
  },
  500137: {
    href: remotePaths.refusalHardCopy,
    icon: 'pochta',
    // hardCopy: rejectHardCopy,
  },
  500132: {
    href: 'https://www.nalog.ru/rn77/service/service_feedback/?service=51',
    icon: 'support',
    external: true,
  },
  500133: { href: routeMap.taxSecrecy, icon: 'transfer' },
  500134: { href: remotePaths.rejectLKFL, icon: 'refuse' },
  500135: { href: remotePaths.profileSign, icon: 'ep' },
  500136: { href: remotePaths.makeComplaint, icon: 'complaint' },
  500139: { href: routeMap.requestForSearchPayment, icon: 'document' },
  500140: { href: routeMap.qualifiedSignatureApplication, icon: 'ep' },
  500141: { href: remotePaths.consentToInform, icon: 'chat' },
  900199: { href: routeMap.appealInFreeForm, icon: 'chat' },
  300139: {
    href: routeMap.objectDestruction,
    icon: 'error',
  },
  300140: {
    href: routeMap.transportDestruction,
    icon: 'error',
  },
  600131: {
    href: remotePaths.registerAsMediator,
    icon: 'registration',
  },
  600132: {
    href: remotePaths.unregisterAsMediator,
    icon: 'registration',
  },
  600133: {
    href: remotePaths.registerAsInsuranceTaxPayer,
    icon: 'registration',
  },
  600134: {
    href: remotePaths.unregisterAsInsuranceTaxPayer,
    icon: 'registration',
  },
  300135: {
    href: routeMap.statementOfEgrn,
    icon: 'document',
  },
  300136: {
    href: remotePaths.noChargesAppeal,
    icon: 'error',
  },
  1000100: {
    href: remotePaths.taxes,
    icon: 'taxes',
  },
  1000110: {
    href: remotePaths.userIncomes,
    icon: 'money',
  },
  1000120: {
    href: remotePaths.taxes,
    icon: 'history',
  },
  1000200: {
    href: remotePaths.propertyObjects,
    icon: 'objects',
  },
  1000300: {
    href: remotePaths.situations,
    icon: 'report',
  },
  1000400: {
    href: remotePaths.contacts,
    icon: 'contacts',
  },
  1000410: {
    href: routeMap.makeAppointment,
    icon: 'write',
  },
  1000500: {
    href: remotePaths.messages,
    icon: 'messages',
  },
  300115: {
    href: routeMap.ndfl3LightIncomeProperty,
    icon: 'rentalIncome',
  },
  300116: {
    href: routeMap.ndfl3LightIncomeRental,
    icon: 'rentalIncome',
  },
  300117: {
    href: routeMap.ndfl3LightDeductionCharity,
    icon: 'charityDeduction',
  },
  300118: {
    href: routeMap.ndfl3LightDeductionIIS,
    icon: 'iisDeduction',
  },
  300112: {
    href: routeMap.ndfl3LightDeductionProperty,
    icon: 'propertyDeduction',
  },
  300113: {
    href: routeMap.ndfl3LightDeductionHealing,
    icon: 'healingDeduction',
  },
  300114: {
    href: routeMap.ndfl3LightDeductionEducation,
    icon: 'educationDeduction',
  },
  100133: {
    href: routeMap.landTaxDeduction,
    icon: 'diploma',
  },
  500138: {
    href: routeMap.setAddressToSendingTaxDocuments,
    icon: 'addLocation',
  },
  1000170: {
    href: remotePaths.checks,
    icon: 'checks',
  },
  1000600: {
    href: remotePaths.userIncomes,
    icon: 'income',
  },
  1000160: {
    href: remotePaths.selfInsuranceTaxes,
    icon: 'moneydop',
  },
  1000610: {
    href: remotePaths.declarationIncomes,
    icon: 'calc',
  },
  1000620: {
    href: routeMap.taxDeductions,
    icon: 'diploma',
  },
  1000171: {
    href: remotePaths.checks,
    icon: 'checks',
  },
  600135: {
    href: remotePaths.innCertificateRequest,
    icon: 'registration',
  },
  1010150: {
    href: remotePaths.profileAccounts,
    icon: 'accountbalance',
  },
  400130: {
    href: remotePaths.profileAccountsAbroad,
    icon: 'accountbalance',
  },
});
